function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import Container, { useLazyload } from './Container';

const Lazyload = ({
  lazyChildren,
  children,
  ...props
}) => {
  const lazyid = useRef(btoa(Math.random().toString()));
  const loaded = useLazyload(lazyid.current);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    "data-lazyid": lazyid.current,
    "data-lazyloaded": loaded
  }), loaded ? children : lazyChildren);
};

Lazyload.Container = Container;
export default Lazyload;